<template>
  <div>
    <div class="d-flex flex-nowrap justify-content-between align-items-center">
      <p
        class="m-0"
        @click="showPricesDetails = !showPricesDetails"
      >
        {{ this.searchParams.bags_number }}
        {{ $tc('lang.bookings.bags', this.searchParams.bags_number) }}
        <strong>{{ prices.symbol +''+ (totalPrice/days).toLocaleString('de-DE') }}</strong>
        /{{ $tc('lang.search.prices.day', 1) }}
      </p>

      <div class="switch-field">
        <input
          id="distance"
          v-model="order"
          type="radio"
          name="order_filter"
          value="distance"
          @click="$emit('orderChanged', 'distance')"
        >
        <label for="distance">{{ $tc('lang.search.filters.distance') }}</label>

        <input
          id="relevance"
          v-model="order"
          type="radio"
          name="order_filter"
          value="relevance"
          @click="$emit('orderChanged', 'relevance')"
        >
        <label for="relevance">{{ $t('lang.search.filters.relevance') }}</label>
      </div>
    </div>

    <div
      v-if="showPricesDetails"
      id="prices-details"
      class="search_mob_wp centered pb-0 mt-2 align-self-end mt-auto"
    >
      <table class="table table-sm prices_table mb-1">
        <tbody>
          <tr>
            <td>
              1 {{ $t('lang.search.prices.bag') }}
              <span class="small">
                <br class="d-block d-sm-block d-md-none">
                (${{ (prices.first_bag.toLocaleString('de-DE') +'/' +$tc('lang.search.prices.day', 1)) }})
              </span>
            </td>
            <td>
              x {{ days }}
              {{ $tc('lang.search.prices.day', days) }}
            </td>
            <th>
              {{ prices.symbol +''+ (prices.first_bag * days).toLocaleString('de-DE') }}
            </th>
          </tr>
          <tr v-if="addBagsNumber > 0">
            <td>
              {{ addBagsNumber }}
              {{ $tc('lang.search.prices.add_bags', addBagsNumber) }}
              <span class="small">
                <br class="d-block d-sm-block d-md-none">
                (${{ (prices.add_bags.toLocaleString('de-DE') +'/' +$tc('lang.search.prices.day', 1)) }})
              </span>
            </td>
            <td>
              x {{ days }}
              {{ $tc('lang.search.prices.day', days) }}
            </td>
            <th>
              {{ prices.symbol +''+ addBagsPrice.toLocaleString('de-DE') }}
            </th>
          </tr>
          <tr>
            <td colspan="2">
              <strong>{{ $t('lang.bookings.total') }}</strong>
            </td>
            <th>{{ prices.symbol +''+ totalPrice.toLocaleString('de-DE') }}</th>
          </tr>
        </tbody>
      </table>
      <div style="line-height: 1.2">
        <small>
          {{ $t('lang.search.prices.insurance') }}
          <a
            href="/terms-and-conditions#insurance"
            target="_blank"
          >{{ $t('lang.home.prices.insurance_cond') }}</a>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PriceInfo',
  props: {
    searchParams: {
      type: Object,
      required: true,
    },
    order: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showPricesDetails: false,
      // LONG BOOKING DISCOUNT PAUSED
      // discountCodeMinDays: process.env.VUE_APP_MIN_DAYS_OF_LONG_BOOKINGS,
    };
  },
  computed: {
    prices() {
      const currency = this.$store.state.main.currency ? this.$store.state.main.currency : 'USD';
      return this.$globalPrices[currency];
    },
    price(type) {
      const startDate = moment(this.searchParams.input_start_date);// now
      const endDate = moment(this.searchParams.input_end_date);

      if (type === 'days') {
        return endDate.startOf('day').diff(startDate.startOf('day'), 'days') + 1;
      }
      return null;
    },

    days() {
      const startDate = moment(this.searchParams.input_start_date);// now
      const endDate = moment(this.searchParams.input_end_date);
      return endDate.startOf('day').diff(startDate.startOf('day'), 'days') + 1;
    },

    addBagsNumber() {
      return this.searchParams.bags_number - 1;
    },

    addBagsPrice() {
      return (this.prices.add_bags
          * parseInt(this.addBagsNumber, 10)
          * parseInt(this.days, 10));
    },

    // LONG BOOKING DISCOUNT PAUSED
    // discountAmount() {
    //   if (this.days >= this.discountCodeMinDays) {
    //     return ((this.prices.first_bag * this.days) + this.addBagsPrice) * 0.20;
    //   }
    //   return 0;
    // },

    totalPrice() {
      // LONG BOOKING DISCOUNT PAUSED
      // return (((this.prices.first_bag * this.days) + this.addBagsPrice) - this.discountAmount);
      return (((this.prices.first_bag * this.days) + this.addBagsPrice));
    },

  },
  watch: {
    order() {
      this.checkOrder();
    },
  },

  mounted() {
    this.checkOrder();
  },

  methods: {
    checkOrder() {
      if (this.order === 'relevance') {
        document.getElementById('relevance').checked = true;
      } else {
        document.getElementById('distance').checked = true;
      }
    },
  },

};
</script>

<style scoped>

</style>
